/* ============================================================================
   mm-global.js — utilitaires globaux Moon Moon
   ----------------------------------------------------------------------------
   Chargé sur toutes les pages par layout/theme.liquid. Contient :
   - la variable CSS --doc-height (hauteur réelle du viewport, fix 100vh iOS) ;
   - les sliders vidéo zoomables des sous-collections
     (snippets/mm-sous-collection-block.liquid : zoom in/out, enchaînement
     auto des slides à la fin de chaque vidéo, style des bullets) ;
   - le menu mobile du header (sections/header.liquid) ;
   - les accordéons génériques (.mm-accordion) et le recalcul de hauteur des
     panneaux <details> (.mm-pf-panel, sections/MM-Video-Onglets.liquid).
   ========================================================================== */

// Pose --doc-height = hauteur réelle du viewport sur <html> (recalculée au
// resize). Contourne le bug des 100vh sur mobile (barres d'URL iOS/Android).
const documentHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty("--doc-height", `${window.innerHeight}px`);
};
window.addEventListener("resize", documentHeight);
documentHeight();
// Snipet mm-sous-collection-block

// ZOOM
// Passe le slider vidéo en plein écran (classe mm-zoom-in) et lance la 1re
// vidéo. Appelée en onclick depuis snippets/mm-sous-collection-block.liquid.
function sliderVideoZoomIn(e, classSlider) {
    var slider = document.querySelector(classSlider);
    var mmVideos = slider.querySelectorAll(".mm-video");

    slider.classList.add("mm-zoom-in");

    mmBgNav(classSlider);
    mmVideos[0].play();
    e = e || window.event;
    e.preventDefault();
}

// Sort du mode zoom : revient à la 1re slide, retire mm-zoom-in et stoppe +
// rembobine toutes les vidéos. Appelée par la croix de fermeture du snippet
// mm-sous-collection-block et par goToNextSlide en fin de diaporama.
function sliderVideoZoomOut(classSlider) {
    goToFirstSlide(classSlider);

    var slider = document.querySelector(classSlider);

    slider.classList.remove("mm-zoom-in");

    var mmVideos = slider.querySelectorAll(".mm-video");
    mmVideos.forEach(function (mmVideo) {
        mmVideo.pause();
        mmVideo.currentTime = 0;
    });
}
// NEXT SLIDE
// Avance le slider en cliquant sur le bullet de pagination Splide suivant ;
// à la dernière slide, on referme le zoom. Appelée par l'attribut onended
// de chaque <video> (snippets/mm-sous-collection-block.liquid) pour faire
// défiler les vidéos automatiquement.
function goToNextSlide(classSlider) {
    var slider = document.querySelector(classSlider);
    var currentBullet = slider.querySelector(".splide__pagination__page.is-active");
    var nextBullet = currentBullet.closest("li").nextSibling;

    if (nextBullet) {
        nextBullet.firstChild.click();
    } else {
        goToFirstSlide(classSlider);
        sliderVideoZoomOut(classSlider);
    }
    // var mmVideos = slider.querySelectorAll('.mm-video');
    // mmVideos.forEach(function(mmVideo){
    //   mmVideo.pause();
    //   mmVideo.currentTime = 0;
    // })

    // var mmSlide = slider.querySelector('.mm-slide-video-slide.is-next');
    // if (mmSlide) {
    //   var mmVideo = mmSlide.querySelector('.mm-video');
    //   mmVideo.play();
    // }
}

// FIRST SLIDE
// Revient à la 1re slide en simulant un clic sur le premier bullet Splide.
function goToFirstSlide(classSlider) {
    var slider = document.querySelector(classSlider);
    var firstBullet = slider.querySelector(".splide__pagination > li:first-child > button");

    firstBullet.click();
}

// BG NAV
// Repeint les bullets de pagination en blanc semi-transparent puis opaque
// (dégradé "demi-cercle"). Sur mobile, ne colore que jusqu'au bullet actif
// inclus (le .every sert de boucle interruptible) ; sur desktop la boucle
// colore tout (le break envisagé est resté commenté). Appelée par
// sliderVideoZoomIn uniquement.
function mmBgNav(classSlider) {
    var slider = document.querySelector(classSlider);
    var bullets = slider.querySelectorAll(".splide__pagination__page");

    bullets.forEach(function (bullet) {
        bullet.style.background = "linear-gradient(to bottom, rgba(255,255,255,0.5) 50%, rgba(255,255,255,0) 50%)";
    });

    if (window.innerWidth < 768) {
        Array.from(bullets).every(function (bullet) {
            bullet.style.background = "linear-gradient(to bottom, rgba(255,255,255,1) 50%, rgba(255,255,255,0) 50%)";
            if (bullet.classList.contains("is-active")) {
                return false;
            } else {
                return true;
            }
        });
    } else {
        bullets.forEach(function (bullet) {
            bullet.style.background = "linear-gradient(to bottom, rgba(255,255,255,1) 50%, rgba(255,255,255,0) 50%)";
            if (bullet.classList.contains("is-active")) {
                // throw BreakError;
            }
        });
    }
}

//Header

// Ouvre/ferme le menu burger mobile (toggle mm-menu-open + blocage du scroll).
// Appelée en onclick par l'icône burger, la croix et l'overlay du menu
// (sections/header.liquid).
function mmMobileMenu() {
    var mobileMenu = document.querySelector(".mm-mobile-menu-wrapper");

    mobileMenu.classList.toggle("mm-menu-open");
    document.querySelector("html").classList.toggle("stop-scrolling");
}

// Toggle générique mm-menu-open sur un sélecteur — aucun appelant trouvé
// dans sections/ ni snippets/ : code mort probable.
function mmMobileAcc(className) {
    var classElem = document.querySelector(className);

    classElem.classList.toggle("mm-menu-open");
}

/* DROPDOWN MOBILE */
// Déplie un sous-menu du menu mobile. Appelée en onclick depuis
// sections/header.liquid : mmMobileDropdown('mm-dropdown-N', this).
// NB : `className.firstChild` sur une string vaut undefined → arrowReverse
// est toujours une collection vide, jamais utilisée (variable morte).
function mmMobileDropdown(className, elem) {
    var menuTitle = document.getElementsByClassName(className);
    var menuLink = menuTitle[0].nextElementSibling;
    var arrowReverse = document.getElementsByClassName(className.firstChild);

    menuLink.classList.toggle("header-active");
    elem.classList.toggle("mm-active");
}


/* Dropdown */
/* dropdown active par default */
// Branche un accordéon animé (max-height) sur chaque .mm-accordion de la
// page (utilisé par sections/MM-Video-Onglets.liquid). Lancée une fois au
// DOMContentLoaded ci-dessous. NB : console.log de debug laissé en prod.
function animatedDropdowns(){
  const faqColl = document.querySelectorAll('.mm-accordion');
  console.log(faqColl);

  let q;

  for (q = 0; q < faqColl.length; q++) {
      faqColl[q].addEventListener('click', function () {
          const content = this.nextElementSibling;
          let contentHeight = content.clientHeight;

          if (contentHeight > 0) {
            content.style.maxHeight = 0;
          } else {
            content.style.maxHeight = content.scrollHeight + "px";
          }

          this.classList.toggle("active");
      });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  animatedDropdowns();
});

// Mobile/tablette (<900px) : quand un <details class="accordion"> s'ouvre à
// l'intérieur d'un panneau .mm-pf-panel (sections/MM-Video-Onglets.liquid),
// le panneau parent animé en max-height doit être agrandi, sinon le contenu
// déplié est coupé. Le setTimeout(0) attend que <details> ait fini de s'ouvrir.
if (window.innerWidth < 900) {
  document.addEventListener("DOMContentLoaded", function () {
    let summaries = document.querySelectorAll(".accordion summary");

    if (summaries) {
      summaries.forEach((summary) => {
        summary.addEventListener("click", function () {
          setTimeout(() => {
            var parentPanel = this.closest(".mm-pf-panel");
            if (parentPanel) {
              parentPanel.style.maxHeight = parentPanel.scrollHeight + "px";
            }
          }, 0); // Timeout pour laisser le `<details>` s'ouvrir
        });
      });
    }
  });
}

// ============================================================================
// 26/08/2026 — Consentement mobile : variable --mm-consent-h
// La bannière cookies native Shopify (#shopify-pc__banner) est compactée en
// barre basse sur mobile (moon-moon.css.liquid). Ce script mesure sa hauteur
// RÉELLE et la pose en variable CSS sur <html> : le padding-bas du body s'en
// décale tant qu'aucun choix n'a été fait (le bas de page reste atteignable
// au scroll), puis revient à 0 dès que Shopify masque/retire la bannière.
// 28/08/2026 : le CTA sticky de la PDP ne consomme PLUS cette variable
// (décision Christopher : le faire flotter au-dessus de la bannière faisait
// bizarre) — seul le body l'utilise désormais.
// Aucune écriture de consentement ici : mesure et style uniquement.
// ============================================================================
(function () {
  var root = document.documentElement;

  function mesureBanniere() {
    var banniere = document.getElementById("shopify-pc__banner");
    var hauteur = 0;
    if (banniere) {
      var style = getComputedStyle(banniere);
      var rect = banniere.getBoundingClientRect();
      if (style.display !== "none" && style.visibility !== "hidden" && rect.height > 1) {
        hauteur = Math.round(rect.height);
      }
    }
    root.style.setProperty("--mm-consent-h", hauteur + "px");
    return !!banniere;
  }

  // La bannière change de taille (rotation, resize) et disparaît au choix :
  // on l'observe directement une fois présente dans le DOM.
  function surveilleBanniere() {
    var banniere = document.getElementById("shopify-pc__banner");
    if (!banniere) return;
    new ResizeObserver(mesureBanniere).observe(banniere);
    new MutationObserver(mesureBanniere).observe(banniere, { attributes: true });
  }

  // Shopify injecte la bannière après le chargement : on guette son arrivée
  // (enfant direct de <body>), puis on coupe ce guetteur global.
  var guetteur = new MutationObserver(function () {
    if (mesureBanniere()) {
      surveilleBanniere();
      guetteur.disconnect();
    }
  });

  function demarre() {
    if (mesureBanniere()) {
      surveilleBanniere();
    } else {
      guetteur.observe(document.body, { childList: true });
    }
    window.addEventListener("resize", mesureBanniere);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", demarre);
  } else {
    demarre();
  }
})();
